module.exports = __webpack_public_path__ + "img/logo-desktop.f95ce6b0.svg";